module.exports = __webpack_public_path__ + "static/media/nature-trail.cf0aafe3.svg";